import { ISavedCv } from 'data-transfers/dto'
import { IGetSavedCvsRequest, ISavedCvRequest } from 'data-transfers/requests'

import { authClient, parseContentRange } from 'utils'

export const getSavedCv = async ({
  advertId,
  ...payload
}: IGetSavedCvsRequest) => {
  const { data, headers } = await authClient.get<ISavedCv[]>(
    `/adverts/${advertId}/candidates`,
    {
      params: payload
    }
  )
  const pagination = parseContentRange(headers)
  return { data, pagination: pagination }
}
export const addSavedCv = async ({
  advertId,
  candidateId
}: ISavedCvRequest) => {
  const { data } = await authClient.post<ISavedCv>(
    `/adverts/${advertId}/candidates/${candidateId}`
  )
  return data
}
export const deleteSavedCv = async ({
  advertId,
  candidateId
}: ISavedCvRequest) => {
  await authClient.delete(`/adverts/${advertId}/candidates/${candidateId}`)
}
